import type { ValidationRule } from './types';

export const validateRules = (validators: ValidationRule[], inputToValidate: string): string[] =>
  validators
    .map(validate => validate(inputToValidate))
    .filter(result => result.error)
    .map(result => result.errorMessage);
